import React, { ReactNode } from 'react';
import {
  OnLinkClickType,
  S4AMastheadProvider,
} from '@spotify-internal/s4x-masthead';
import '@spotify-internal/s4x-masthead/styles/index.css';
import { getSpotifyClientId } from '../@mrkt/features/env';
import { useLanguageSelectionContext } from '../../features/src/i18n/components/LanguageSelection';
import { useLocale, useRtl } from '../../features/src/i18n';
import { getLanguage } from './getLanguage';

export const MastheadProvider = ({
  children,
  onLinkClick,
}: {
  children: ReactNode;
  onLinkClick: (x: OnLinkClickType) => any;
}) => {
  const locale = useLocale();
  const rtl = useRtl();
  const { dispatch } = useLanguageSelectionContext();
  return (
    <S4AMastheadProvider
      onLinkClick={(link: OnLinkClickType) => {
        onLinkClick(link);
      }}
      isFrodor
      clientId={getSpotifyClientId()}
      trackCat="TrackCategory"
      language={{
        dir: rtl ? 'rtl' : 'ltr',
        locale: getLanguage(locale),
        onClick: () => dispatch({ type: 'open' }),
        marketSelectReturnToPath: '',
        useCountryRegionPicker: false,
      }}
    >
      {children}
    </S4AMastheadProvider>
  );
};
